export class PhoneFormState {
  readonly phone: string = "";
  readonly agreement: boolean = true;
  readonly name?: string = "";
  readonly additionalAgreement?: boolean = true;
}